import React from 'react';
import Modal from '../../component/modal';

import './dialog.less';

let _dialog = null;
// 销毁组件
const destroy = () => {
    if (_dialog) {
        _dialog();
        _dialog = null;
    }
};
// 显示一个confirm
const confirm = (props) => {
    //  保证只有一个实例
    destroy();
    const {
        title = '',
        content = '',
        showOk = true,
        showCancel = true,
        okText = UG.lang.template('Confirm'),
        cancelText = UG.lang.template('Cancel'),
        okClick = destroy,
        cancelClick = destroy
    } = props;

    let buttons = [];
    if (showCancel) {
        buttons.push(
            <div
                key="cancel"
                className="btn-cancel"
                onClick={cancelClick.bind(null, destroy)}>
                {cancelText}
            </div>
        );
    }
    if (showOk) {
        buttons.push(
            <div
                key="ok"
                className="btn-ok"
                onClick={okClick.bind(null, destroy)}>
                {okText}
            </div>);
    }
    //  一般会有两个按钮，只有一个按钮目前没有用到，用到的时候需要特殊处理下
    let contentComp = (
        <div className="dialog">
            <h3 className="dialog-title text-center">{title}</h3>
            <div className="dialog-content text-center">
                {content}
            </div>
            <div className="dialog-buttons">
                {buttons}
            </div>
        </div>
    );

    _dialog = Modal.createNoHeader(contentComp, 'dialog-extra');

    return _dialog;
};
export default {confirm};



// WEBPACK FOOTER //
// ./js/host/common/dialog.js